import { useMemo } from 'react';

import { getRevenueFromResponseCurve } from '../forecast/forecastData';

export const usePredictedRevenue = (rawData, trainingData, responseCurves, features) => {
  /* eslint-disable no-param-reassign */

  const predRevenueByDate = useMemo(() => {
    if (!rawData || !trainingData || !responseCurves || !features) return {};

    const revByDay = {};

    features.forEach(selectedFeature => {
      const currentSpendEffectData = rawData.spend_effect.filter(x => x.feature_name === selectedFeature.value);
      const responseCurve = responseCurves[selectedFeature.value];

      const _byDay = trainingData.map(x => {
        const revenue = getRevenueFromResponseCurve(responseCurve, x[selectedFeature.value]);

        return {
          day: x.date,
          revenue,
        };
      });

      const byDay = _byDay.reduce((byDate, row, position) => {
        const { revenue } = row;

        currentSpendEffectData.forEach(spendEffectDay => {
          const { day_in_window, spend_effect } = spendEffectDay;
          const targetRow = _byDay[position + day_in_window];
          if (!targetRow) return;

          const { day } = targetRow;
          const newRow = byDate[day] || { ...targetRow, normalizedRevenue: 0 };
          const contribution = revenue * (spend_effect || 0);
          newRow.normalizedRevenue += contribution;
          byDate[day] = newRow;
        });
        return byDate;
      }, {});

      const finalData = (currentSpendEffectData.length > 0) ? byDay : _byDay;
      Object.keys(finalData).forEach(day => {
        revByDay[day] = revByDay[day] || 0; // assign default if does not exist
        revByDay[day] += finalData[day].normalizedRevenue;
      });
    });

    return revByDay;
  }, [rawData, trainingData, responseCurves]);

  return {
    predRevenueByDate,
  };
};
